import { useMemo } from "react";
import { Issue } from "@adsk/acc-issues-types";

const NEW_ISSUE_THRESHOLD_SECONDS = 3;

export const useIsIssueJustCreated = (issue: Issue | undefined): boolean => {
  return useMemo(() => {
    if (!issue?.createdAt || !issue?.id) {
      return false;
    }

    const createdAtDate = new Date(issue.createdAt);
    const differenceInSeconds = (Date.now() - createdAtDate.getTime()) / 1000;
    return differenceInSeconds <= NEW_ISSUE_THRESHOLD_SECONDS;
  }, [issue?.id, issue?.createdAt]);
};
